export default __webpack_public_path__ + "case-study-items-section.png";